import React from "react";

export const Loader = () => {
  return (
    <div class="ui active dimmer">
      <div class="ui text huge loader">Loading</div>
    </div>
  );
};
